module.exports = __webpack_public_path__ + "29b00ebcf93fda46ac9957fa4816eafd.ttf";